import React, { useEffect } from "react";
// nodejs library to set properties for components
import PropTypes from "prop-types";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import Chip from '@material-ui/core/Chip';
// @material-ui/icons
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import TextField from '@material-ui/core/TextField';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Typography from '@material-ui/core/Typography';
import Select from '@material-ui/core/Select';
import styles from "assets/jss/material-kit-react/components/profileStyle.js";
import Button from '@material-ui/core/Button';
import Paper from '@material-ui/core/Paper';
import swal from 'sweetalert'
import Axios from "axios";
import Config from "../../config.js"
var md5 = require('md5');
const useStyles = makeStyles(styles);

export default function ChangePassword(props) {
  const { user } = props;
  const classes = useStyles();
  const [state, setState] = React.useState({
    password: "",
    passwordRepeat: "",
  });

  const handleTextBoxChange = (event) => {
    setState({ ...state, [event.target.name]: event.target.value });
  };
  var Call = () => {
    if (state.password != state.passwordRepeat) {
      return swal("کلمه های عبور یکی نیستند.")
    }
    Axios.post(Config.api + "Authentication/ChangePassword", {
      password:md5(state.password)
    },
      {
        headers: {
          apikey: Config.apikey,
          Authorization: "Bearer " + localStorage.getItem('token')
        }
      }).then((result) => {
        localStorage.clear();
        swal("با موفقیت انجام شد. لازم است مجددا وارد شوید.").then(()=>{
          window.location="/SignIn";
        })
       
      }).catch((err) => {
        if (err&&err.response&&err.response.status&&err.response.status == 422)
          swal("پارامترهای ارسالی نادرست است.");
          else if(err&&err.response&& err.response.data&&err.response.data.fa_message){
          swal(err.response.data.fa_message);
          }
        else if (err&&err.response&&err.response.data&&err.response.data.message&&err.response.data.message.pr)
          swal(err.response.data.message.pr);
        else swal("خطایی رخ داده است.")
      })
  }
  return (
    <form noValidate autoComplete="off">
      <GridContainer className={classes.root} justify="center">
        <GridItem xs={12} sm={12} md={12}>
          <Paper className={classes.paper} variant="outlined" >

            <GridContainer>
              <GridItem xs={12} sm={12} md={12}>
                <div className={classes.div}>
                  <Typography variant="h6" gutterBottom>
                   تغییر کلمه عبور
      </Typography>
                  <div className={classes.formInput}>
                    <TextField type="password" id="standard-basic" name="password" value={state.password} onChange={handleTextBoxChange} label="کلمه عبور" />
                  </div>
                  <div className={classes.formInput}>
                    <TextField type="password" id="standard-basic" name="passwordRepeat" value={state.passwordRepeat} onChange={handleTextBoxChange} label="تکرار کلمه عبور"  />
                  </div>
                  <br />
                  <div className={classes.formInput}>
                    <Button variant="contained" color="secondary" disableElevation onClick={Call}>
                      تغییر کلمه عبور
                    </Button>
                  </div>
                </div>
              </GridItem>
             </GridContainer>
          </Paper>
        </GridItem>
      </GridContainer>
    </form>
  );
}